import { ButtonProps } from "fe-shared/src/components";
import { CheckIcon, CloseIcon } from "fe-shared/src/components/Icons";
import {
  Transfer,
  TransferStatus,
  TransferType,
} from "fe-shared-transactions/src/types";

import styles from "../TransferDetails.module.scss";

export enum TransferAction {
  Cancel = "Cancel",
  Invalidate = "Invalidate",
  Approve = "Approve",
}

export type ActionPermissions = { [key in TransferAction]?: boolean };

export interface ActionConfig {
  name: TransferAction;
  isVisible: (
    transfer: Transfer,
    permissions: ActionPermissions,
    isCurrentUserAssignee: boolean
  ) => boolean;
  isDisabled?: (transfer: Transfer) => boolean;
  hasConfirmationDialog: boolean;
  buttonProps: Partial<ButtonProps>;
  dialogButtonProps?: Partial<ButtonProps>;
}

const {
  IntoProcessing,
  OutOfProcessing,
  NonEligibleWriteOff,
  NonEligibleBufferWriteOff,
  PickupFromStorage,
  DeliveryToStorage,
} = TransferType;

const CancelActionVisibleTypesMap: TransferType[] = [
  NonEligibleWriteOff,
  NonEligibleBufferWriteOff,
];

const InvalidateActionVisibleTypesMap: TransferType[] = [
  IntoProcessing,
  OutOfProcessing,
  PickupFromStorage,
  DeliveryToStorage,
];

const ApproveActionVisibleTypesMap: TransferType[] = [
  NonEligibleWriteOff,
  NonEligibleBufferWriteOff,
];

const CancelActionVisibleStatusMap: TransferStatus[] = [
  TransferStatus.Submitted,
  TransferStatus.InReview,
];

const InvalidateActionVisibleStatusMap: TransferStatus[] = [
  TransferStatus.Approved,
];

const ApproveActionVisibleStatusMap: TransferStatus[] = [
  TransferStatus.InReview,
];

export const actions: ActionConfig[] = [
  {
    name: TransferAction.Approve,
    isVisible: (t, permissions, isCurrentUserAssignee) =>
      isCurrentUserAssignee &&
      !!permissions[TransferAction.Approve] &&
      ApproveActionVisibleStatusMap.includes(t.statusCode) &&
      ApproveActionVisibleTypesMap.includes(t.transferType),
    hasConfirmationDialog: false,
    buttonProps: {
      variant: "filled",
      iconComponent: CheckIcon,
      className: styles.approve,
    },
    dialogButtonProps: {
      variant: "filled",
    },
  },
  {
    name: TransferAction.Cancel,
    isVisible: (t, permissions, isCurrentUserAssignee) =>
      !!permissions[TransferAction.Cancel] &&
      CancelActionVisibleStatusMap.includes(t.statusCode) &&
      (t.isAdjustable ||
        (t.statusCode === TransferStatus.InReview && isCurrentUserAssignee)) &&
      CancelActionVisibleTypesMap.includes(t.transferType),
    hasConfirmationDialog: true,
    buttonProps: {
      variant: "filled",
      iconComponent: CloseIcon,
      className: styles.cancel,
    },
    dialogButtonProps: {
      variant: "filled",
      iconComponent: CheckIcon,
    },
  },
  {
    name: TransferAction.Invalidate,
    isVisible: (t, permissions) =>
      !!permissions[TransferAction.Invalidate] &&
      t.isInClosurePeriod &&
      InvalidateActionVisibleStatusMap.includes(t.statusCode) &&
      InvalidateActionVisibleTypesMap.includes(t.transferType),
    hasConfirmationDialog: true,
    buttonProps: {
      variant: "filled",
      iconComponent: CloseIcon,
      className: styles.cancel,
    },
    dialogButtonProps: {
      variant: "filled",
      iconComponent: CheckIcon,
    },
  },
];
